<template>
  <div class="markingRecord-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- tab栏 -->
      <div class="section-mian_right">
        <ioc-tab-group
          ref="tabs"
          :option="tabOption"
          @change="handleChange"
        ></ioc-tab-group>

        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <template slot="search_time">
              <div>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择开始时间"
                  v-model="searchParams.startTime"
                  style="width: 182px"
                ></el-date-picker>
                <span style="padding: 0 5px">至</span>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择结束时间"
                  v-model="searchParams.endTime"
                  default-time="23:59:59"
                  style="width: 182px"
                ></el-date-picker>
              </div>
            </template>
            <!-- 表格按钮 自定义 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
            <template slot="fileCode" slot-scope="scope">
              {{ scope.row.fileCode }}
              <img
                :src="getImgPath(scope.row.fileCode)"
                @click="showViewer(getImgPath(scope.row.fileCode), $event)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 25px; width: 50px"
              />
            </template>
            <!-- 查看详情表单 自定义 -->
            <template slot="fileCodeView" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.fileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
              />
            </template>
            <!--  姓名 点击跳转详情 -->
            <template slot="personName" slot-scope="scope">
              <span
                style="cursor: pointer"
                @click="handleView(scope.row, scope.index)"
              >
                {{ scope.row.personName }}</span
              >
            </template>
            <!--  车牌号 点击跳转详情 -->
            <template
              v-if="matchType.typeId == '2'"
              slot="plateNo"
              slot-scope="scope"
            >
              <span
                style="cursor: pointer"
                @click="handleView(scope.row, scope.index)"
              >
                {{ scope.row.plateNo }}</span
              >
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>
<script>
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic, Bus, Dates } from "$utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../config/table";
export default {
  components: {},
  data() {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      tabOption: {
        column: [
          {
            label: "行人",
            prop: "people",
            typeId: 1,
          },
          {
            label: "机动车辆",
            prop: "car",
            typeId: 2,
          },
        ],
      },
      tableOption: tableOption(true, true),
      // 分页属性设置
      page: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      matchType: {},
      tableData: [],
      searchParams: {},
      queryForm: {
        startTime: "",
        endTime: "",
      },
    };
  },
  created() {
    // 默认进入页面选中第一种分类方式
    this.matchType = this.tabOption.column[0];
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    timeChange(data) {},
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(src, e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    handleView(row, index) {
      this.$refs.accessTab.rowView(row, index);
    },
    // 切换选项卡
    handleChange(column) {
      this.matchType = column;
      if (this.matchType.typeId === 1) {
        this.tableOption = tableOption(true, true);
        this.getList(1);
      } else {
        this.tableOption = tableOption(false, true);
        this.getList(2);
      }
    },
    // 获取列表
    getList(matchType) {
      const params = {};
      params.matchType = matchType;
      params.pageNum = this.page.pageNum;
      params.pageSize = this.page.pageSize;
      params.startTime = this.searchParams.startTime
        ? Dates.format(this.searchParams.startTime)
        : "";
      params.endTime = this.searchParams.endTime
        ? Dates.format(this.searchParams.endTime)
        : "";

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.queryMarkingList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },

    // 查询按钮事件
    searchResult(param) {
      if (this.matchType.prop === "people") {
        //  this.searchParams = Object.assign(param);
        this.page.pageNum = 1;
        this.getList(1);
      } else {
        //  this.searchParams = Object.assign(param);
        this.page.pageNum = 1;
        this.getList(2);
      }
    },
    // 重置按钮
    resetQuery() {
      this.searchParams.startTime = "";
      this.searchParams.endTime = "";
      if (this.matchType.prop === "people") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.pageNum = val;
      //调用列表接口
      if (this.matchType.prop === "people") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      //调用列表接口
      if (this.matchType.prop === "people") {
        this.getList(1);
      } else {
        this.getList(2);
      }
    },
  },
};
</script>
<style lang="scss" scope>
.markingRecord-container {
  width: 100%;
  height: 100%;
}
</style>
